<div class="modal-backdrop" *ngIf="showModal" (click)="close()"></div>

<div class="modal-container" *ngIf="showModal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-warehouse"></i>
        <h2>Selecionar Almoxarifado</h2>
      </div>
      <button class="btn-close" (click)="close()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Search Bar -->
    <div class="modal-search">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input 
          type="text" 
          class="search-input" 
          [(ngModel)]="searchTerm"
          (input)="onSearch()"
          placeholder="Buscar por nome, responsável, localização, telefone ou email..."
          autofocus>
      </div>
    </div>

    <!-- Warehouse List -->
    <div class="modal-body">
      <div class="warehouses-list">
        <div 
          *ngFor="let warehouse of filteredWarehouses"
          class="warehouse-item"
          [class.selected]="selectedWarehouse?.id === warehouse.id"
          (click)="selectWarehouse(warehouse)">
          <div class="warehouse-icon">
            <i class="fas fa-warehouse"></i>
          </div>
          <div class="warehouse-info">
            <div class="warehouse-name">{{ warehouse.nome }}</div>
            <div class="warehouse-details">
              <span><i class="fas fa-user-tie"></i> {{ warehouse.responsavel }}</span>
              <span><i class="fas fa-map-marker-alt"></i> {{ warehouse.localizacao }}</span>
            </div>
            <div class="warehouse-contact">
              <span><i class="fas fa-phone"></i> {{ warehouse.telefone }}</span>
              <span><i class="fas fa-envelope"></i> {{ warehouse.email }}</span>
            </div>
          </div>
          <div class="warehouse-check" *ngIf="selectedWarehouse?.id === warehouse.id">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>

        <div class="no-results" *ngIf="filteredWarehouses.length === 0">
          <i class="fas fa-search"></i>
          <p>Nenhum almoxarifado encontrado</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="close()" type="button">
        <i class="fas fa-times"></i>
        Cancelar
      </button>
      <button 
        class="btn btn-primary" 
        (click)="confirmSelection()" 
        type="button"
        [disabled]="!selectedWarehouse">
        <i class="fas fa-check"></i>
        Selecionar
      </button>
    </div>
  </div>
</div>
